import client from './client'

const unwrapData = (res) => res.data?.data

export const refreshTokens = (refreshToken) =>
  client.post('/auth/refresh', { refreshToken }).then(unwrapData)

export const getCurrentUser = () =>
  client.get('/me').then(unwrapData)
